<template>
  <v-app>
    <v-container>
      <PitchEnglishHomeApplicationTemplate>
        <router-view
      /></PitchEnglishHomeApplicationTemplate>
    </v-container>
  </v-app>
</template>
<script>
import PitchEnglishHomeApplicationTemplate from "@/template/ApplicationTemplate";
export default {
  components: {
    PitchEnglishHomeApplicationTemplate,
  },
};
</script>
